import React, { Component } from 'react';
import SocialMedia from "components/Components/Includes/SocialMedia";
import PropTypes from "prop-types";

class ContactInfo extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const {
            borderColor
        } = this.props;

        return (
            <>
                <div className={`tw-flex tw-content-center tw-flex-wrap tw-text-left tw-mx-2 tw-border-b tw-pb-5 ${borderColor}`}>
                    <div className="tw-w-full md:tw-w-1/3 md:tw-pr-2 tw-mb-10 lg:tw-mb-0">
                        <h4 className="tw-uppercase font-sp tw-mb-8">Address</h4>
                        <p className="tw-mb-1">2420 NE 186th St. Suite 401</p>
                        <p className="tw-mb-1">North Miami Beach, FL 33180</p>
                    </div>
                    <div className="tw-w-full md:tw-w-1/3 md:tw-px-2 tw-mb-10 lg:tw-mb-0">
                        <h4 className="tw-uppercase font-sp tw-mb-8">Contact</h4>
                        <a className="hover:tw-text-orange-400 tw-block tw-mb-1" href="mailto:info@luxuriavacations.com">info@luxuriavacations.com</a>
                        <span>Phone Number: </span><a className="hover:tw-text-orange-400 tw-block tw-mb-1" href="tel:18447858575">1 (844) 785-8575</a>
                        <span>Emergency Line (24/7): </span><a className="hover:tw-text-orange-400 tw-block tw-mb-1" href="tel:18447858575">1 (844) 785-8575 Ext. 2</a>
                    </div>
                    <div className="tw-w-full md:tw-w-1/3 md:tw-pl-2 tw-mb-10 lg:tw-mb-0">
                        <h4 className="tw-uppercase font-sp tw-mb-8">Hours</h4>
                        <p className="tw-mb-1">Monday to Friday</p>
                        <p className="tw-mb-1">9:00 am - 7:00 pm</p>
                    </div>
                </div>
                <div className="tw-flex tw-justify-center tw-flex-wrap tw-mx-2 tw-pt-5">
                    <div className="tw-w-auto">
                        <SocialMedia />
                    </div>
                </div>
            </>
        );
    }
}

ContactInfo.propTypes = {
    borderColor: PropTypes.string,
};

export default ContactInfo;
